import React from 'react';
import Slider from 'react-slick';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { images } from '../../../shared/assets/images';

function PrevArrow({ onClick }) {
  return (
    <button
      className="absolute left-0 top-1/2 -translate-y-1/2 bg-white rounded-full shadow-lg p-3 hover:bg-orange-400 hover:text-white transition z-20"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faChevronLeft} />
    </button>
  );
}

function NextArrow({ onClick }) {
  return (
    <button
      className="absolute right-0 top-1/2 -translate-y-1/2 bg-white rounded-full shadow-lg p-3 hover:bg-orange-400 hover:text-white transition z-20"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faChevronRight} />
    </button>
  );
}

function Card({ image, title }) {
  return (
    <div className="px-2 py-4">
      <div className="overflow-hidden rounded-xl shadow-xl hover:shadow-2xl transform transition duration-500 hover:scale-105 bg-white">
        <img src={image} alt={title} className="w-full h-[250px] object-cover" />
        <div className="p-4">
          <h3 className="text-xl font-bold text-blue-900 text-center">{title}</h3>
        </div>
      </div>
    </div>
  );
}

export default function AttractionsCarousel() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section id="informacion" className="relative py-20 px-4 z-10">
      <div className="container mx-auto px-4 relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 via-orange-500 to-pink-500 text-center mb-12 drop-shadow-md">
          ¡Descubre nuestras atracciones!
        </h2>

        <Slider {...settings}>
          <Card image={images.trampoline} title="Cama Elástica" />
          <Card image={images.combatBridge} title="Puente Combate" />
          <Card image={images.bridge} title="Puente Colgante" />
          <Card image={images.basketballZone} title="Zona Baloncesto" />
          <Card image={images.jumpingZone} title="Zona Jumping" />
        </Slider>
      </div>
    </section>
  );
}
